export const failedMsg = 'Sorry Process Failed !! Please Try Again.'   
export const loadMsg = ' Data Loaded Successfully'
export const saveMsg = ' Data Saved Successfully'
export const updateMsg = ' Data Updated Successfully'
export const deleteMsg = ' Data Deleted Successfully'
export const FillUpRequiredFiled = 'Fill up all required field!'
export const emptyData = 'Data not found!'



// WEBPACK FOOTER //
// ./src/vuex/erpUtil.js